import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import LoadingMoveez from "../Lottie/LoadingMoveez";
import { useAtom } from "jotai";
import { setShowUploadModal, showUploadModalAtom } from "../../jotai-store/uploadImages";

const ReusableModal = ({
  isOpen = false,
  onClose = () => { },
  showLoading = false,
  showConfirm = false,
  onConfirm = () => { },
  confirmDisabled = false,
  children, // optional children
  handleUpdateBookingObject,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [showUploadModal, setShowUploadImageModal] = useAtom(showUploadModalAtom);

  const handleAddItemsManually = () => {
    handleUpdateBookingObject("tripStatus", "uploadimages", "Click on Add Items Manually Button")
    setShowUploadImageModal(true);
    onClose(); // Close the current modal
  }

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [isOpen]);
  if (!isOpen) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-end justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={`absolute left-0 h-[90%] md:h-[500px] right-0 bottom-0 transform transition-transform duration-300 ease-out w-full bg-white rounded-t-[18px] shadow-xl border border-[#e6eefc] px-8 py-6 flex flex-col justify-between ${isVisible ? "translate-y-0" : "translate-y-full"
          }`}
      >
        {/* Header */}
        <div className="relative flex items-center justify-center h-[40px]">
          <button
            onClick={onClose}
            className="absolute left-0 top-0 text-[#CDCCD7] disabled:cursor-not-allowed"
            disabled={showLoading}
          >
            <img
              src="/Vision Agent Icons/X Icon/XLightpurple.svg"
              alt="Close"
            />
          </button>
        </div>

        {/* MAIN CONTENT — children optional */}
        <div className="flex-1 overflow-auto">
          {showLoading ? <LoadingMoveez /> : children ?? null}
        </div>

        {/* Bottom actions */}
        <div className="relative h-24 flex flex-col gap-y-4 items-center justify-center w-full max-w-container md:max-w-[500px]">

          <button
            onClick={() => handleAddItemsManually()}
            style={{
              border: "2px solid #34318C",
              padding: "12px",
              borderRadius: "8px",
              width: "100%",
              height: "44.38px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
            }}
            className="font-semibold text-[#34318C] text-[16px] mt-4"
          >
            <img src="/images/NewUiIcons/Camera Roll Icon - Light Purple (1).svg" alt="camera icon" />
            Add photos for best accuracy
          </button>

          <button
            onClick={onConfirm}
            disabled={confirmDisabled}
            className={
              `${showConfirm
                ? 'bg-gradient-to-t from-[#4743BF] to-[#211F59] text-white'
                : 'bg-gray-200 text-gray-400'
              } p-3 rounded-[8px] w-full h-[44.38px] flex items-center justify-center gap-3 font-semibold disabled:cursor-not-allowed text-[16px]`
            }
          >
            Save & Continue <img src="/images/NewUiIcons/Group85.svg" alt="arrow" className="inline ml-2" />
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReusableModal;
